/* ViaDünya native interactions — no external libraries or tracking. */
document.addEventListener('DOMContentLoaded', () => {
  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 2 }).format(value);
    } catch (e) {
      return `${value.toFixed(2)} TL`;
    }
  };

  document.querySelectorAll('[data-auto-submit]').forEach(select => {
    select.addEventListener('change', () => select.closest('form')?.requestSubmit());
  });

  const updateHeaderCartCount = (delta = 1) => {
    const cartIcon = document.querySelector('.cart-icon');
    if (!cartIcon) return;
    let badge = cartIcon.querySelector('.cart-count');
    const current = Number(badge?.textContent || 0);
    const next = current + delta;
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'cart-count';
      cartIcon.appendChild(badge);
    }
    badge.textContent = String(next);
    cartIcon.setAttribute('aria-label', `Sepet, ${next} ürün`);
  };

  document.querySelectorAll('[data-product-root]').forEach(root => {
    const input = root.querySelector('input[name="quantity"]');
    root.querySelector('[data-qty-decrease]')?.addEventListener('click', () => {
      if (input) input.value = String(Math.max(1, (parseInt(input.value, 10) || 1) - 1));
    });
    root.querySelector('[data-qty-increase]')?.addEventListener('click', () => {
      if (input) input.value = String((parseInt(input.value, 10) || 0) + 1);
    });
    const variants = root.querySelector('[data-variant-select]');
    const cards = Array.from(root.querySelectorAll('[data-variant-card]'));
    const syncFromOption = (option) => {
      if (!option) return;
      const price = root.querySelector('[data-current-price]');
      if (price) {
        const priceCents = Number(option.dataset.priceCents || 0);
        const compareCents = Number(option.dataset.compareCents || 0);
        let html = `<span class="product-price__current">${option.dataset.price || ''}</span>`;
        if (compareCents > priceCents && option.dataset.compare) {
          const discount = Math.round(((compareCents - priceCents) / compareCents) * 100);
          html += ` <s class="product-price__old">${option.dataset.compare}</s>`;
          if (discount > 0) html += ` <span class="product-price__badge">${discount}% indirim</span>`;
        }
        price.innerHTML = html;
      }
      const button = root.querySelector('[data-atc]');
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.innerHTML = button.disabled ? 'Tükendi' : 'Sepete ekle <span aria-hidden="true">↗</span>';
      }
      cards.forEach(card => {
        const active = String(card.dataset.variantId) === String(option.value);
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const chosenColor = option.dataset.option;
      const gallery = root.querySelector('[data-local-gallery]');
      if (gallery && chosenColor) {
        const matchingImage = Array.from(gallery.querySelectorAll('[data-local-color]')).find(el => el.dataset.localColor === chosenColor);
        if (matchingImage) gallery.scrollTo({ left: matchingImage.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      }
      const featuredMediaId = option.dataset.mediaId;
      if (featuredMediaId) {
        const mediaFigure = root.querySelector('#media-' + featuredMediaId);
        const mediaStrip = root.querySelector('.gallery-primary');
        if (mediaFigure && mediaStrip) mediaStrip.scrollTo({ left: mediaFigure.offsetLeft - mediaStrip.offsetLeft, behavior: 'smooth' });
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState(null, '', url.toString());
    };

    variants?.addEventListener('change', () => syncFromOption(variants.selectedOptions[0]));
    cards.forEach(card => {
      card.addEventListener('click', () => {
        if (!variants) return;
        const targetOption = Array.from(variants.options).find(option => String(option.value) === String(card.dataset.variantId));
        if (!targetOption) return;
        variants.value = targetOption.value;
        variants.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (variants) syncFromOption(variants.selectedOptions[0]);
  });

  const modal = document.querySelector('[data-quick-add-modal]');
  if (modal) {
    const dialog = modal.querySelector('[role="dialog"]');
    const optionsWrap = modal.querySelector('[data-quick-add-options]');
    const submit = modal.querySelector('[data-quick-add-submit]');
    const price = modal.querySelector('[data-quick-add-price]');
    const title = modal.querySelector('#QuickAddTitle');
    const copy = modal.querySelector('[data-quick-add-copy]');
    const errorMessage = modal.querySelector('[data-quick-add-error]');
    let selectedVariant = null;
    let previousFocus = null;
    let isSubmitting = false;

    const normalise = (s) => String(s || '').trim().toLowerCase();
    const closeModal = () => {
      if (isSubmitting) return;
      modal.hidden = true;
      document.body.classList.remove('modal-open');
      optionsWrap.replaceChildren();
      submit.disabled = true;
      price.textContent = 'Seçim yapın';
      errorMessage.hidden = true;
      errorMessage.textContent = '';
      selectedVariant = null;
      if (previousFocus?.isConnected) previousFocus.focus();
    };

    const openModal = (card) => {
      if (!card) return;
      const jsonNode = card.querySelector('[data-quick-add-variants]');
      if (!jsonNode) return;
      let variants = [];
      try { variants = JSON.parse(jsonNode.textContent || '[]'); }
      catch (error) { return; }
      const productTitle = card.dataset.productTitle || 'Ürün';
      const optionName = card.dataset.productOptionName || 'Seçenek';
      const isBundle = card.dataset.isBundle === 'true' || normalise(optionName).includes('paket');
      const isZekaFix = normalise(productTitle).includes('zeka fix');
      previousFocus = document.activeElement;
      selectedVariant = null;
      isSubmitting = false;
      submit.disabled = true;
      submit.innerHTML = 'Sepete ekle <span aria-hidden="true">↗</span>';
      price.textContent = 'Seçim yapın';
      errorMessage.hidden = true;
      errorMessage.textContent = '';
      title.textContent = isBundle ? 'PAKET AL & TASARRUF ET' : `${optionName} seçin`;
      copy.textContent = isBundle ? `${productTitle} için paketini seç, ardından sepete ekle.` : `${productTitle} için bir seçenek seç, ardından sepete ekle.`;
      optionsWrap.replaceChildren();
      optionsWrap.classList.toggle('variant-card-grid--campaign', isBundle);
      dialog.classList.toggle('quick-add-modal__dialog--bundle', isBundle);

      // Theme files cannot create paid Shopify bundle variants. If there is only
      // one default variant for a campaign, never present false package prices.
      if (isBundle && variants.length < 2) {
        const warning = document.createElement('p');
        warning.className = 'quick-add-modal__empty';
        warning.textContent = 'Paket seçenekleri şu anda kullanılamıyor.';
        optionsWrap.appendChild(warning);
        submit.disabled = true;
      } else {
        variants.forEach((variant) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = isBundle ? 'variant-card variant-card--campaign' : 'variant-card';
          button.setAttribute('aria-pressed', 'false');
          button.disabled = !variant.available;
          button.dataset.variantId = String(variant.id);

          const name = String(variant.option1 || variant.title || 'Seçenek');
          const discountExists = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
          if (isBundle) {
            const num = Number(name.match(/^[1-9]\d*/)?.[0] || 0);
            if (num === 2 || num === 3) {
              const ribbon = document.createElement('span');
              ribbon.className = 'variant-card__ribbon';
              ribbon.textContent = num === 2 ? 'En Çok Satan' : 'En Uygun Fiyat';
              button.appendChild(ribbon);
            }
            const radio = document.createElement('span');
            radio.className = 'variant-card__radio';
            radio.setAttribute('aria-hidden', 'true');
            button.appendChild(radio);
          }
          const copyWrap = document.createElement('span');
          copyWrap.className = isBundle ? 'variant-card__copy' : 'variant-card__simple-copy';
          const label = document.createElement('span');
          label.className = 'variant-card__title';
          label.textContent = name;
          copyWrap.appendChild(label);
          if (isBundle && isZekaFix) {
            const num = Number(name.match(/^[1-9]\d*/)?.[0] || 0);
            if (num) {
              const sub = document.createElement('span');
              sub.className = 'variant-card__subline';
              sub.textContent = `${num * 64} Parça`;
              copyWrap.appendChild(sub);
            }
          }
          button.appendChild(copyWrap);
          const priceWrap = document.createElement('span');
          priceWrap.className = 'variant-card__pricing';
          const current = document.createElement('span');
          current.className = 'variant-card__price';
          current.textContent = formatMoney(variant.price);
          priceWrap.appendChild(current);
          if (discountExists) {
            const compare = document.createElement('s');
            compare.textContent = formatMoney(variant.compare_at_price);
            priceWrap.appendChild(compare);
          }
          if (!variant.available) {
            const stock = document.createElement('span');
            stock.className = 'variant-card__meta';
            stock.textContent = 'Tükendi';
            priceWrap.appendChild(stock);
          }
          button.appendChild(priceWrap);
          button.addEventListener('click', () => {
            optionsWrap.querySelectorAll('.variant-card').forEach((el) => {
              el.classList.remove('is-active');
              el.setAttribute('aria-pressed', 'false');
            });
            button.classList.add('is-active');
            button.setAttribute('aria-pressed', 'true');
            selectedVariant = variant;
            price.replaceChildren(document.createTextNode(formatMoney(variant.price)));
            if (discountExists) {
              const old = document.createElement('s');
              old.textContent = formatMoney(variant.compare_at_price);
              price.append(' ', old);
            }
            errorMessage.hidden = true;
            submit.disabled = false;
          });
          optionsWrap.appendChild(button);
        });
      }
      modal.hidden = false;
      document.body.classList.add('modal-open');
      dialog.focus();
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quick-add-trigger]');
      if (!button) return;
      event.preventDefault();
      openModal(button.closest('[data-product-card]'));
    });
    modal.querySelectorAll('[data-quick-add-close]').forEach((button) => button.addEventListener('click', closeModal));
    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); closeModal(); }
      if (event.key !== 'Tab') return;
      const focusables = Array.from(dialog.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled)'));
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { last.focus(); event.preventDefault(); }
      else if (!event.shiftKey && document.activeElement === last) { first.focus(); event.preventDefault(); }
    });
    submit.addEventListener('click', async () => {
      if (!selectedVariant || isSubmitting) return;
      isSubmitting = true;
      submit.disabled = true;
      submit.textContent = 'Ekleniyor…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(selectedVariant.id), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('add_failed');
        updateHeaderCartCount(1);
        isSubmitting = false;
        closeModal();
      } catch (error) {
        errorMessage.textContent = 'Ürün sepete eklenemedi. Stok durumunu kontrol edip yeniden deneyin.';
        errorMessage.hidden = false;
      } finally {
        isSubmitting = false;
        submit.innerHTML = 'Sepete ekle <span aria-hidden="true">↗</span>';
        submit.disabled = !selectedVariant;
      }
    });
  }
});
